import { BuyButton } from 'src/components/restructure/product/sections/Sidebar/ProductAction/BuyButton'
import { useContext } from 'react'
import {
  ENABLE_GUEST_CHECKOUT_EXPERIMENT_ID,
  PDP_BUY_BUTTON_EXPERIMENT_ID,
} from 'src/components/common/StatsigExposure/StatsigExposure'
import { Statsig } from 'src/sdk/statsig'

import { CashbackHighlightSection } from './CashbackHighlightSection'
import { ProductContext } from '../../../contexts'

interface CmsSections {
  id: string
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
}

type ProductActionProps = {
  cmsData?: {
    name: string
    sections?: CmsSections[]
  }
}

export function ProductAction({ cmsData }: ProductActionProps) {
  const { quantity } = useContext(ProductContext)
  const isGuestCheckoutEnabled = Statsig.useStatsigFeatureGateValue(
    ENABLE_GUEST_CHECKOUT_EXPERIMENT_ID
  )

  const isPdpBuyNowCtaExperimentEnabled = Statsig.useStatsigFeatureGateValue(
    PDP_BUY_BUTTON_EXPERIMENT_ID
  )

  const buttonContainerClasses = isGuestCheckoutEnabled
    ? isPdpBuyNowCtaExperimentEnabled
      ? 'flex items-center w-full gap-2'
      : 'flex flex-col items-center w-full gap-2'
    : 'flex items-center w-full'

  const buttons = isGuestCheckoutEnabled ? (
    isPdpBuyNowCtaExperimentEnabled ? (
      <>
        <BuyButton
          quantity={quantity}
          loaderVariant="white"
          type="buyNow"
          className="!bg-restructure-background-black transition text-white hover:!bg-black !rounded-none !px-4 !py-4 !min-h-[64px] text-sm !leading-[27px] font-medium"
          cmsData={cmsData}
        />

        <BuyButton
          quantity={quantity}
          loaderVariant="white"
          visualMode="icon"
          className="shrink-0"
          cmsData={cmsData}
        />
      </>
    ) : (
      <>
        <BuyButton
          quantity={quantity}
          loaderVariant="white"
          type="buyNow"
          cmsData={cmsData}
        />
        <BuyButton
          quantity={quantity}
          loaderVariant="black"
          cmsData={cmsData}
        />
      </>
    )
  ) : (
    <BuyButton quantity={quantity} loaderVariant="black" cmsData={cmsData} />
  )

  return (
    <section className="mt-7 mb-4" data-component="product-action">
      <CashbackHighlightSection />
      <div
        className={buttonContainerClasses}
        data-testid="product-action-buttons"
      >
        {buttons}
      </div>
    </section>
  )
}
